import { createEventBusModule } from 'hooks/eventBus';
import { UPDATE_SAVING_RULES_FAILURE } from './actions/types';
const MODULE_NAME = 'Pots';
export const MIN_POT_DEPOSIT_AMOUNT = 1;
const createEventBusModuleEvent = createEventBusModule(MODULE_NAME);
// Bus events
const UPDATE_SAVING_RULES_FAILURE_EVENT = createEventBusModuleEvent(UPDATE_SAVING_RULES_FAILURE);
export const busEvents = {
    UPDATE_SAVING_RULES_FAILURE_EVENT,
};
export const AUTOSAVE_MIN_AMOUNT = 10;
export const AUTOSAVE_DEFAULT_WEEKLY_AMOUNT = 25;
export const AUTOSAVE_DEFAULT_MONTHLY_AMOUNT = 100;
export const AUTOSAVE_WEEKLY_INVESTMENT_AMOUNTS = [10, 25, 50];
export const AUTOSAVE_MONTHLY_INVESTMENT_AMOUNTS = [50, 100, 250];
export const POT_DEPOSIT_AMOUNT_OPTIONS = [50, 100, 250];
export const POTS_MAXIMUM_DD_DEPOSIT_LIMIT = 1500;
export const POTS_MAXIMUM_OB_DEPOSIT_LIMIT = 1000000;
